import { render, staticRenderFns } from "./MediaDetail.vue?vue&type=template&id=82c54f3c&scoped=true&"
import script from "./MediaDetail.vue?vue&type=script&lang=js&"
export * from "./MediaDetail.vue?vue&type=script&lang=js&"
import style0 from "./MediaDetail.vue?vue&type=style&index=0&id=82c54f3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c54f3c",
  null
  
)

export default component.exports